import { useState, cloneElement, Children } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Popover, Box, useMediaQuery, useTheme } from '@mui/material';
import { CreateButton } from 'react-admin';
import DotsIcon from '@/assets/icons/dots-icon.svg?react';
import CustomCreateButton from '@/components/global/buttons/CustomCreateButton';

const isCreateAction = child => {
    if (!child || typeof child !== 'object' || !('type' in child)) {
        return false;
    }

    return child.type === CreateButton || child.type === CustomCreateButton;
};

const CustomToolbarActionsPopover = ({ children, showOnMobile = false }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [anchorEl, setAnchorEl] = useState(null);
    const validChildren = Children.toArray(children).filter(Boolean);
    const hasCreateAction = validChildren.some(isCreateAction);

    if (validChildren.length === 0) {
        return null;
    }

    if (isMobile && !hasCreateAction && !showOnMobile) {
        return null;
    }

    const handleToggle = event => {
        if (anchorEl) {
            setAnchorEl(null);
        } else {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const isOpen = Boolean(anchorEl);

    return (
        <>
            <IconButton onClick={handleToggle} className={isOpen ? 'active' : ''} variant='contained' color='secondary' size='large'>
                <DotsIcon />
            </IconButton>

            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                className='more-area'
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                disableScrollLock
                disableEnforceFocus
                disablePortal
            >
                <Box className='more-content'>
                    {Children.map(children, child => {
                        if (child && typeof child === 'object' && 'type' in child) {
                            return cloneElement(child, { onClose: handleClose });
                        }
                        return child;
                    })}
                </Box>
            </Popover>
        </>
    );
};

CustomToolbarActionsPopover.propTypes = {
    children: PropTypes.node,
    showOnMobile: PropTypes.bool,
};

export default CustomToolbarActionsPopover;
